const cartEventArray = ["rebuy:cart.ready", "rebuy:cart.change"];
const cartEvents = ["rebuy.ready", "rebuy.change", "rebuy.productsChange"];

cartEventArray.forEach(event => {
    document.addEventListener(event, () => {
        setTimeout(() => {
            const itemCountElements = document.querySelectorAll(".cart-count");

            [...itemCountElements].forEach(element => {
                element.innerText = Rebuy.Cart.itemCount();
            });

            const subtotalNumber = Rebuy.SmartCart.subtotalNumber();
            const calculatedCartDiscount = Rebuy.SmartCart.getCalculatedCartDiscount();
            const subtotalElement = document.getElementById("subtotalSmartCartText");

            updatePrice(subtotalNumber, calculatedCartDiscount, subtotalElement);
        })
    })
});

cartEvents.forEach(event => {
    document.addEventListener(event, function(e) {
        setTimeout(() => {
            const cartWidgetItemElements = document.querySelectorAll(".rebuy-widget-content .rebuy-product-info");
            const selectedProductsW = window.selectedProducts;
            
            if (selectedProductsW && selectedProductsW.length > 0) {
                cartWidgetItemElements.forEach(cartWidgetItemElement => {
                    const titleElement = cartWidgetItemElement.querySelector(".rebuy-product-title");
                    const priceElement = cartWidgetItemElement.querySelector(".rebuy-product-price .rebuy-money > span + span");
        
                    if (titleElement && priceElement) {
                        const selectedProductInRecommendations = selectedProductsW.find(item => item.title === titleElement.innerText);
        
                        if (selectedProductInRecommendations) {
                            priceElement.innerText = selectedProductInRecommendations.price;
                        }
                    }
                })
            }
        })
    });
})

const updatePrice = (subtotalNumber, calculatedCartDiscount, element) => {
    if(!element) return;

    const moneyFormat = window.price.money_format;
    const compareAtPrice = subtotalNumber + calculatedCartDiscount;
    const formattedPrice = formatMoney(subtotalNumber, moneyFormat);
    const formattedCompareAtPrice = formatMoney(compareAtPrice, moneyFormat);
    
    if (element.children.length > 0) {
        const priceEl = element.querySelector(".rebuy-cart__flyout-subtotal-final-amount");
        const compareEl = element.querySelector(".rebuy-cart__flyout-subtotal-compare-amount");
        
        if (priceEl) priceEl.innerText = formattedPrice;
        if (compareEl) {
            compareEl.innerText = formattedCompareAtPrice;

            if (subtotalNumber === compareAtPrice) {
                compareEl.setAttribute("class", "rebuy-cart__flyout-subtotal-compare-amount hidden")
            } else {
                compareEl.setAttribute("class", "rebuy-cart__flyout-subtotal-compare-amount")
            }
        } 
    } else {
        element.innerText = formattedPrice;
    }
}